/** AVCS coverage value → display label mapping. */
export const COVERAGE_DISPLAY_LABELS: Record<string, string> = {
  UnitBerthing: 'Berthing',
  UnitHarbour: 'Harbor',
  UnitApproach: 'Approach',
  UnitCoastal: 'Coastal',
  UnitGeneral: 'General',
  FolioTransit: 'Overview',
};

/** Coverage z-index: smaller area → higher z-index (rendered on top). */
export const COVERAGE_Z_INDEX: Record<string, number> = {
  UnitBerthing: 6,
  UnitHarbour: 5,
  UnitApproach: 4,
  UnitCoastal: 3,
  UnitGeneral: 2,
  FolioTransit: 1,
};

/** Product type z-index: AVCS (top) → e-NP → ADP (bottom). */
export const PRODUCT_TYPE_Z_INDEX: Record<string, number> = {
  AVCS: 3,
  'e-NP': 2,
  ADP: 1,
};

/** All coverage API values. */
export const COVERAGE_VALUES = Object.keys(COVERAGE_Z_INDEX);

/** Map a backend coverage value to its display label. Returns null for null/undefined input. */
export function coverageLabel(value?: string | null): string | null {
  if (!value) return null;
  return COVERAGE_DISPLAY_LABELS[value] ?? value;
}
